module.exports = __webpack_public_path__ + "img/kc.136aa917.svg";